var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivitylogGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.827 21C9.96285 21 8.14665 20.3984 6.63859 19.2811C5.13053 18.164 4.00805 16.5888 3.43203 14.7811C2.85599 12.9736 2.85599 11.0264 3.43203 9.21884C4.00805 7.41126 5.13053 5.836 6.63859 4.71884C8.14665 3.6017 9.96285 3 11.827 3C13.691 3 15.5072 3.6017 17.0153 4.71885C18.5233 5.836 19.6458 7.41126 20.2218 9.21885C20.7978 11.0264 20.7978 12.9736 20.2218 14.7811M18.9375 13L20.1635 15L22.125 13.5",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.5C9.5 10.8807 10.6193 12 12 12C13.3807 12 14.5 10.8807 14.5 9.5C14.5 8.11929 13.3807 7 12 7C10.6193 7 9.5 8.11929 9.5 9.5Z",
    stroke: "#C0CDE2",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitylogGrey);
export default __webpack_public_path__ + "static/media/Activity log - Grey.4bce40922b8d06d109078f5996759541.svg";
export { ForwardRef as ReactComponent };